class API {
  constructor () {
    this.axios = require('axios/index')
    this.prefix = window.rootPath + '/api/v1'
  }

  call (method, url, data) {
    bus.$emit('loading')
    return this.axios({
      url: url,
      method: method,
      data: data
    })
  }

  getCore (callback) {
    this.call('GET', this.prefix).then(response => {
      callback(response)
      bus.$emit('stop-loading')
    }, (response) => {
      bus.$emit('error-loading')
    })
  }

  getTiles (callback, term = '') {
    let url = this.prefix + '/tiles/' + term
    if (term === '') {
      url = this.prefix + '/tiles'
    }
    this.call('GET', url).then(response => {
      callback(response)
      bus.$emit('stop-loading')
    }, (response) => {
      bus.$emit('error-loading')
    })
  }

  getGame (gameId, callback) {
    this.call('GET', this.prefix + '/game/' + gameId).then(response => {
      callback(response)
      bus.$emit('stop-loading')
    }, (response) => {
      bus.$emit('error-loading')
    })
  }

  async getLesson (lessonId, callback) {
    await this.call('GET', this.prefix + '/lesson/' + lessonId).then(response => {
      callback(response)
      bus.$emit('stop-loading')
    }, (response) => {
      bus.$emit('error-loading')
    })
  }

  getJourney(journeyId, callback) {
    this.call('GET', this.prefix + '/journey/' + journeyId).then(response => {
      callback(response)
      bus.$emit('stop-loading')
    }, (response) => {
      bus.$emit('error-loading')
    })
  }

  getHelp (routeName, callback) {
    this.call('GET', this.prefix + '/help/' + routeName).then(response => {
      callback(response)
      bus.$emit('stop-loading')
    }, (response) => {
      bus.$emit('error-loading')
    })
  }

  getTerms (callback) {
    this.call('GET', this.prefix + '/terms').then(response => {
      callback(response)
      bus.$emit('stop-loading')
    }, (response) => {
      bus.$emit('error-loading')
    })
  }
}

export default API
